<template>
    <CRow>
        <CCol>
            <CCard>
                <CCardHeader>
                    <strong>Настройка "скидки" за n-заказов</strong>
                </CCardHeader>
                <CCardBody>
                    <CRow class="pl-3 pb-3" />
                    <CForm>
                        <CRow>
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">
                                Активен
                            </CCol>
                            <CCol sm="9">
                                <CSwitch
                                    :checked.sync="discount_on_orders.enabled"
                                    color="success"
                                    shape="pill"
                                    variant="opposite"/>
                            </CCol>
                        </CRow>
                        <CInput
                            v-model="discount_on_orders.description"
                            label="Описание (добавляется к описанию примененного промокода (для клиента))"
                            placeholder="Скидка 10%. + ТЕКСТ"/>
                        <CInput
                            v-model="discount_on_orders.orders_count"
                            type="number"
                            label="Количество заказов"/>
                        <label>Текст push-уведомления</label>
                        <CInput
                            v-model="discount_on_orders.title_push"
                            style="margin-left:50px"
                            label="Заголовок"/>
                        <CInput
                            v-model="discount_on_orders.description_push"
                            style="margin-left:50px"
                            label="Описание"/>
                        <CRow>
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">Активный промокод</CCol>
                            <CCol
                                sm="9"
                                class="col-form-label"
                                v-if="discount_on_orders.active_promocode_id && promocode">
                                <CLink 
                                    :to="{ path: `/promocodes/${discount_on_orders.active_promocode_id}` }"> 
                                    {{ promocode.code }} 
                                </CLink>
                            </CCol>
                        </CRow>
                    </CForm>
                </CCardBody>
                <CCardFooter>
                    <CButton
                        color="primary"
                        class="mr-3"
                        @click="save"
                    >Сохранить</CButton>
                    <CButton
                        color="light"
                        class="mr-3"
                        @click="goBack"
                    >Отмена</CButton>
                </CCardFooter>
            </CCard>
        </CCol>
    </CRow>
</template>

<script>
    import Vue from 'vue';

    export default {
        name: 'DiscountOnOrdersSettings',

        data() {
            return {
                discount_on_orders: {
                    enabled: false,
                    description: '',
                    title_push: '',
                    description_push: '',
                    orders_count: null,
                    active_promocode_id: null,
                },
                promocode: null,
            };  
        },

        async mounted() {
            const data = (await Vue.axios.get('/discount-on-orders')).data;
            if (data && data[0]?.id) {
                this.discount_on_orders = data[0];
            }
            if (this.discount_on_orders.active_promocode_id) {
                const promocode = (await Vue.axios.get(`/promocodes/${this.discount_on_orders.active_promocode_id}`)).data;
                this.promocode = promocode;
            }
        },  

        methods: {
            async save() {
                try {
                    this.discount_on_orders.orders_count = +this.discount_on_orders.orders_count;
                    await Vue.axios.put('/discount-on-orders', this.discount_on_orders);
                    this.$router.go(0);
                } catch (e) {
                    this.$root.$emit('showError', 'Ошибка сохранения.')
                    console.log(e);
                }
            },
            goBack() {
                this.$router.push({ path: '/dashboard' });
            },
        },
    };
</script>
